import {Component, Input} from '@angular/core';
import {ReportService} from "../service/report.service";
import {AtaskaitosParametraiApi} from '../api/ataskaitos-parametrai.api';

@Component({
  selector: 'gii-reports',
  templateUrl: './gii-reports.component.html',
  styleUrl: './gii-reports.component.css'
})
export class PalygVmiAtaskaitaComponent {
  @Input() ataskId!: any;
  @Input() ataskaitosParametrai!: any;
  isLoading = false;

  constructor(private reportService: ReportService) {
  }

  eksportuoti(): void {
    this.isLoading = true;

    switch (this.ataskId) {
      case 1:
        this.ataskaitosParametrai.ataskaitosTipas = 'PALYG_VMI_ATASK';
        this.generuotiAtaskaita(this.ataskaitosParametrai);
        break;
      case 2:
        this.ataskaitosParametrai.ataskaitosTipas = 'TIEKIMO_RINKAI_ATASKAITA';
        this.generuotiAtaskaita(this.ataskaitosParametrai);
        break;
      case 3:
        this.ataskaitosParametrai.ataskaitosTipas = 'REGISTRACIJOS_DUOMENU_ATASKAITA';
        this.generuotiAtaskaita(this.ataskaitosParametrai);
        break;
      default:
        break;
    }
  }

  generuotiAtaskaita(ataskaitosParametrai: AtaskaitosParametraiApi) {
    this.isLoading = true;

    this.reportService.generuotiAtaskaita(ataskaitosParametrai).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'ataskaita.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Error while downloading the report:', error);
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

}
